module.exports = __webpack_public_path__ + "media/images/team_membership_pallavi_class-7c4fe1fa6456664565621cbfe07a1a2d.png";